module.exports = __webpack_public_path__ + "static/img/16.f9cbb21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/16.png
// module id = Gdtf
// module chunks = 0